import { render, staticRenderFns } from "./importPersonnel.vue?vue&type=template&id=45487b3e&scoped=true"
import script from "./importPersonnel.vue?vue&type=script&lang=js"
export * from "./importPersonnel.vue?vue&type=script&lang=js"
import style0 from "./importPersonnel.vue?vue&type=style&index=0&id=45487b3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45487b3e",
  null
  
)

export default component.exports